enum EveRoutes {
  // EVE HOME UI ROUTES
  HOME = '/home',
  LOGIN_DOT_GOV_HOME = '/home/loginDotGov',
  LOGIN = '/home/login',
  LOGIN_DOT_GOV_LOGIN = '/home/login/loginDotGov',
  SITEMAP = '/home/sitemap',

  RESOURCES_PREFIX = '/home/resources',
  RESOURCES_VIEW = '/home/resources/view-essential-resources',
  RESOURCES_VIEW_TRAINING = '/home/resources/view-everifyplus-training',
  RESOURCES_MANUAL = '/home/resources/manual',
  RESOURCES_NEWS = '/home/resources/news',
  RESOURCES_CONTACT_US = '/home/resources/contact',

  // EVE USER UI ROUTES
  USER_PROFILE_PREFIX = '/users/profile',
  USER_PROFILE = '/users/profile',
  USER_PROFILE_EDIT = '/users/profile/edit',
  USER_PASSWORD_EDIT = '/users/profile/change-password',

  COMPANY_USERS_PREFIX = '/users',
  COMPANY_USERS = '/users',
  COMPANY_USERS_NEW = '/users/new',
  COMPANY_VIEW_USER = '/users/:userId',
  COMPANY_EDIT_USER = '/users/:userId/edit',
  COMPANY_RESET_USER_PASSWORD = '/users/:userId/reset-password',

  CORPORATE_USERS_PREFIX = '/users/administrators',
  CORPORATE_USERS = '/users/administrators',
  CORPORATE_USERS_NEW = '/users/administrators/new',
  CORPORATE_VIEW_USER = '/users/administrators/:userId',
  CORPORATE_EDIT_USER = '/users/administrators/:userId/edit',
  CORPORATE_RESET_USER_PASSWORD = '/users/administrators/:userId/reset-password',

  CORPORATE_COMPANY_LOCATIONS_USERS_PREFIX = '/users/company-location-users',
  CORPORATE_COMPANY_LOCATIONS_USERS = '/users/company-location-users',
  CORPORATE_COMPANY_LOCATIONS_USERS_NEW = '/users/company-location-users/new',
  CORPORATE_COMPANY_LOCATIONS_VIEW_USER = '/users/company-location-users/:userId',
  CORPORATE_COMPANY_LOCATIONS_EDIT_USER = '/users/company-location-users/:userId/edit',
  CORPORATE_COMPANY_LOCATIONS_RESET_USER_PASSWORD = '/users/company-location-users/:userId/reset-password',

  // ENROLLMENT UI ROUTES
  ACCOUNT_ENROLLMENT = '/account/new',
  ACCOUNT_ENROLL = '/account/enroll',
  ACCOUNT_ENROLL_VERIFY_OTC = '/account/new/code/:otc',
  ACCOUNT_ENROLL_NEW = '/account/enroll/new',

  // EVE ACCOUNT UI ROUTES
  LOGOUT = '/account/logout',
  COMPANY_PROFILE_VIEW = '/account/company/profile',
  COMPANY_ADDRESS_EDIT = '/account/company/address/edit',
  COMPANY_COMPANY_INFO_EDIT = '/account/company/company-information/edit',
  COMPANY_EMPLOYER_CATEGORY_EDIT = '/account/company/employer-category/edit',
  COMPANY_HIRING_SITES_EDIT = '/account/company/hiring-sites/edit',
  COMPANY_CLOSE = '/account/company/close',

  CORPORATE_PROFILE_VIEW = '/account/corporate/profile',
  CORPORATE_ADDRESS_EDIT = '/account/corporate/address/edit',
  CORPORATE_COMPANY_INFO_EDIT = '/account/corporate/company-information/edit',
  CORPORATE_CLOSE = '/account/corporate/close',

  CORPORATE_COMPANY_LOCATIONS_PREFIX = '/account/corporate/company-locations',
  CORPORATE_COMPANY_LOCATIONS_VIEW = '/account/corporate/company-locations',
  CORPORATE_COMPANY_LOCATIONS_NEW = '/account/corporate/company-locations/new',
  CORPORATE_COMPANY_LOCATIONS_CLOSE = '/account/corporate/company-locations/close',

  CORPORATE_COMPANY_LOCATIONS_CHILD_PREFIX = '/account/corporate/company-locations/:subAccountId',
  CORPORATE_COMPANY_LOCATIONS_CHILD_PROFILE_VIEW = '/account/corporate/company-locations/:subAccountId/profile',
  CORPORATE_COMPANY_LOCATIONS_CHILD_ADDRESS_EDIT = '/account/corporate/company-locations/:subAccountId/address/edit',
  CORPORATE_COMPANY_LOCATIONS_CHILD_COMPANY_INFO_EDIT = '/account/corporate/company-locations/:subAccountId/company-information/edit',
  CORPORATE_COMPANY_LOCATIONS_CHILD_EMPLOYER_CATEGORY_EDIT = '/account/corporate/company-locations/:subAccountId/employer-category/edit',
  CORPORATE_COMPANY_LOCATIONS_CHILD_HIRING_SITES_EDIT = '/account/corporate/company-locations/:subAccountId/hiring-sites/edit',

  COMPANY_CLIENTS_PREFIX = '/account/company/clients',
  COMPANY_CLIENTS_VIEW = '/account/company/clients',
  COMPANY_CLIENTS_NEW = '/account/company/clients/new',
  COMPANY_CLIENTS_CLOSE = '/account/company/clients/close',

  COMPANY_CLIENTS_CLIENT_PREFIX = '/account/company/clients/:subAccountId',
  COMPANY_CLIENTS_CLIENT_PROFILE_VIEW = '/account/company/clients/:subAccountId/profile',
  COMPANY_CLIENTS_CLIENT_ADDRESS_EDIT = '/account/company/clients/:subAccountId/address/edit',
  COMPANY_CLIENTS_CLIENT_COMPANY_INFO_EDIT = '/account/company/clients/:subAccountId/company-information/edit',
  COMPANY_CLIENTS_CLIENT_EMPLOYER_CATEGORY_EDIT = '/account/company/clients/:subAccountId/employer-category/edit',
  COMPANY_CLIENTS_CLIENT_HIRING_SITES_EDIT = '/account/company/clients/:subAccountId/hiring-sites/edit',
  COMPANY_CLIENTS_CLIENT_MOU_UPLOAD = '/account/company/clients/:subAccountId/mou/upload',

  // EVE CASES UI ROUTES
  CASES_PREFIX = '/c/cases',
  CASES_VIEW = '/c/cases',
  CASES_NEW = '/c/cases/new',
  CASES_DRAFT = '/c/cases/draft',

  // ENROLLMENTS RAILS APP ROUTES
  CLIENTS_PREFIX = '/clients',
  CLIENTS_VIEW = '/clients',
  CLIENTS_NEW = '/clients/new',

  // EVE EMULATORS UI ROUTES
  WS_SELF_TEST_SIMULATOR = '/e/',

  REDIRECT_LOADING = '/redirect',
  TUTORIAL = '/tutorial',
  REPORTS = '/reports',

  // EVERIFY+ ROUTES
  I9_TRAINING = '/everifyplus-training',
  EVERIFY_PLUS_TOS = '/everifyplus-terms-of-service',

  // BULK UPLOAD
  CSV_GUIDELINES = '/csv-guidelines',

  // DASHBOARD ROUTES
  DASHBOARD = '/dashboard',
  DASHBOARD_NOT_FOUND = '/dashboard/not-found',
}

export default EveRoutes;
